import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  createContext,
} from "react";
import { Canvas, useLoader, useThree } from "@react-three/fiber";
import { LinearToneMapping } from "three";

import { useNavigate } from "react-router-dom";

import OrbitCam from "../components/OrbitCam";
import GlfLoader from "../components/GltfLoader";
import GltfLoaderAni from "../components/GltfLoaderAni";
import { Stats } from "@react-three/drei";

import Collectible from "../components/Collectible_Item";
import Level from "../blocks/Level";

import { DataContext } from "../../../common/logic/Fetch";

import PopUpWin from "../components/UI/PopUpWin";
import HUD from "../components/UI/HUD";

import * as THREE from "three";

//not in use add for update.
import TouchIcon from "../components/UI/TouchIcon";

import Lable from "../components/Label";


import Repley from "../components/UI/Replay";

export default function ThreeCanavas() {
  //json data
  const { data, loading } = useContext(DataContext);
  const [levelConfigurations, setLevelConfigurations] = useState([]);

  // for testing
  const directionalLightRef = useRef();

  //game lodgic
  const [currentLevel, setCurrentLevel] = useState(0);
  const [displayTime, setDisplayTime] = useState(0);
  const [displayScore, setDisplayScore] = useState(0);
  const [key, setKey] = useState(0);

  const [gameStarted, setGameStarted] = useState(false);
  const [showPopup, SetShowPopup] = useState(true);

  const [popUpTxt, SetPopUpTxt] = useState("");
  const [touchIcon, SettouchIcon] = useState(false);
  const [popUpTxtBody, SetPopUpTxtBody] = useState("you have 5 seconds");
  const [popButtonTxt, SetPopUpButtonTxt] = useState("play");

  // const [playButton, SetplayButton] = useState();
  const [loaded, setLoaded] = useState(false);

  const navigate = useNavigate();

  const canvasRef = useRef(null);

  const saveAsJpg = () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/jpeg");

    const link = document.createElement("a");
    link.href = dataURL;
    link.download = "canvas_image.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    try {
      // if (data && data.plots) {
      if (data) {
        const LevelArr = Object.keys(data).map((key) => ({
          timerDuration: data[key].timerDuration,
          collectibles: data[key].collectibles.map((item) => ({
            pos: item.pos,
            rot: item.rot,
            scale: item.scale,
            col: item.col,
          })),
        }));

        setLevelConfigurations(LevelArr);

        setTimeout(() => {
          setLoaded(true);
        }, 500); // 2 seconds delay
      }
    } catch (err) {}
  }, [data]);

  // const handleStartGame = () => {
  //   setCurrentLevel(0); // Start from level 1
  //   setGameStarted(true);
  // };

  const playGame = () => {
    setDisplayScore(0);

    SetShowPopup(false);
    setGameStarted(true);
    SettouchIcon(true)
  };

  const handleLevelComplete = () => {
    // setCurrentLevel((prevLevel) => prevLevel + 1);

    if (currentLevel + 1 === levelConfigurations.length) {
      // alert("Win!!!");

      navigate(process.env.PUBLIC_URL + "/win");

      // setGameStarted(false);

      // //popup window that you have wone!!
      // SetPopUpTxt("you win it all!! well done!!!");
      // SetPopUpButtonTxt("play again");
      // SetShowPopup(true);

      // //reset to play again
      // setCurrentLevel(0);
      // //reload level
      // setKey(Math.random());
    } else {
      //stop game
      setGameStarted(false);

      //popup window
      SetPopUpTxt("CONGRATULATIONS!!");
      SetPopUpButtonTxt("play");
      SetShowPopup(true);

      //set next level
      setCurrentLevel(currentLevel + 1);
      //reload level
      setKey(Math.random());
    }
  };

  const handleLevelFail = () => {
    playAudioOnce();
    //stop game
    setGameStarted(false);

    //popup window
    SetPopUpTxt("OH NO, TRY AGAIN!");
    SetPopUpButtonTxt("Replay Level");
    SetShowPopup(true);

    //reload level
    setKey(Math.random());
    // Change the key to force re-render of Level component
    // alert("You failed the level. Try again!");
  };

  const handleTimeUpdate = (time) => {
    setDisplayTime(time);
  };

  const handleScoreUpdate = (score) => {
    setDisplayScore(score);
  };

  // const resetGame = () => {
  //   setCurrentLevel(1);
  //   setDisplayTime(0);
  //   setDisplayScore(0);
  //   setKey((prevKey) => prevKey + 1); // Change the key to force re-render of Level component
  // };

  //-------------------------------------------------------------------------
  // PLAY AUDIO SOUNDS

  //play clap audio
  // const audioRef = useRef();
  // Create audio listener
  const listener = new THREE.AudioListener();

  // Create audio source

  const audio = new THREE.Audio(listener);
  // Load audio file
  const audioLoader = new THREE.AudioLoader();
  audioLoader.load(
    process.env.PUBLIC_URL + "/audio/WhaWha.mp3",
    function (buffer) {
      audio.setBuffer(buffer);
      audio.setVolume(0.5); // Set audio volume
    }
  );

  // Function to play audio once
  const playAudioOnce = () => {
    audio.play();
  };
  //

  //

  //----------------------------------------------------------------------------
  //resize canvas
  //----------------------------------------------------------------------------
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerWidth * 0,
  });

  useEffect(() => {
    try {
      function handleResize() {
        setDimensions({
          width: window.innerWidth,
          height: window.innerWidth * 0,
        });
      }

      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    } catch (err) {
      // showBoundary(err)
    }
  }, []);

  const debugClick = () => {
    console.log(levelConfigurations);

    console.log(levelConfigurations[0].collectibles[0]);
  };

  //apply liniar tone mapping
  function ToneMapping() {
    const { gl, scene } = useThree(({ gl, scene }) => ({ gl, scene }));
    useEffect(() => {
      gl.toneMapping = LinearToneMapping;
      gl.toneMappingExposure = 1.5;
      scene.traverse((object) => {
        if (object.material) {
          object.material.needsUpdate = true;
        }
      });
    }, [gl, scene]);
    return <></>;
  }

  // alert(data)
  //----------------------------------------------------------------------------

  function LoadingScreen() {
    return <div className="loader"></div>;
  }

  if (data !== null && levelConfigurations.length > 0) {
    return (
      <div className="gamePage">
        {/* debug buttons */}
        {/* <button
          style={{
            width: "200px",
            height: "100px",
          }}
          onClick={saveAsJpg}
        >
          SAVE canvas
        </button> */}
        {/* <button onClick={debugClick}>DEBUG dta</button> */}

        {/* //////////////////////////////////////////////////////////////// */}

        {!loaded && <LoadingScreen />}
        {/* put UI element here or move to parent */}

        <TouchIcon showWin={touchIcon}/>

        {/* <Repley /> */}

        <PopUpWin
          clickFunction={playGame}
          showWin={showPopup}
          buttonTxt={popButtonTxt}
        >
          <h1> {popUpTxt}</h1>
          <h1>Get ready for Level {currentLevel + 1}</h1>
          <h2>
            Collect{" "}
            <strong>
              {levelConfigurations[currentLevel].collectibles.length} Bears
            </strong>
          </h2>
          <h2>
            You have{" "}
            <strong>
              {levelConfigurations[currentLevel].timerDuration} seconds{" "}
            </strong>
          </h2>
          <br />
        </PopUpWin>

        <HUD
          level={currentLevel + 1}
          foundItems={displayScore}
          itemsLeft={
            levelConfigurations[currentLevel].collectibles.length - displayScore
          }
          timer={displayTime}
          showWin={true}
        />

        {/* #################################################### */}

        {/* OVERLAY DIV GARDIENT */}
        <div className="gadiantOverlay"></div>

        <Canvas
          //for screengarb only
          ref={canvasRef}
          // gl={{ logarithmicDepthBuffer: true, preserveDrawingBuffer: true }}
          //################################

          // ref={canvasRef}
          style={{
            // backgroundColor: "white",
            backgroundColor: "#bbd7c8",
            //used for render only
            // height: "2000px",
            // width: "2000px",

            width: dimensions.width,
            height: dimensions.height,

            minHeight: "100vh",
          }}
          //fix z fighting off for screengrab
          gl={{ logarithmicDepthBuffer: true }}

          // linear
        >
          <ToneMapping />
          {/* ############################################################# */}
          {/* GAME LEVELS */}
          {/* ############################################################# */}

          {gameStarted && (
            <Level
              key={key}
              timerDuration={levelConfigurations[currentLevel].timerDuration} // Adjusted to use displayTime if it's non-zero
              collectibles={levelConfigurations[currentLevel].collectibles}
              onLevelComplete={handleLevelComplete}
              onLevelFail={handleLevelFail}
              onTimeUpdate={handleTimeUpdate}
              onScoreUpdate={handleScoreUpdate}
            >
              {levelConfigurations[currentLevel].collectibles.map(
                (item, index) => {
                  // console.log(item.postion)

                  return (
                    <Collectible
                      key={index}
                      rotation={item.rot}
                      position={item.pos}
                      scale={item.scale}
                      tint={item.col}
                    />
                  );
                }
              )}
            </Level>
          )}

          {/* ############################################################# */}

          {/* STATIC content */}

          <OrbitCam />
          {/* <ambientLight intensity={1} /> */}

          <ambientLight intensity={1} />
          <directionalLight
            intensity={2.5}
            position={[100, 100, -100]}
            // color="yellow"
            ref={directionalLightRef}
          />

          {/* direct light helper */}
          {/* {directionalLightRef.current && (
            <directionalLightHelper args={[directionalLightRef.current, 1]} />
          
          )} */}

          {/* <HorizonLineHelper height={0} /> */}

          {/* mesh to show center of site 0,0,0 */}
          {/* <mesh position={[0, 0, 0]}>
            <boxGeometry args={[20, 20, 20]} />
            <meshStandardMaterial color="red" />
          </mesh> */}

          {/* base level model mesh */}
          <GlfLoader
            MeshPath={process.env.PUBLIC_URL + "/Geo/largeSitetest.glb"}
          />
          {/* animated cars */}
          <GltfLoaderAni
            MeshPath={process.env.PUBLIC_URL + "/Geo/aniCar_01.glb"}
            speed={0.3}
            offset={10}
          />
          <GltfLoaderAni
            MeshPath={process.env.PUBLIC_URL + "/Geo/aniCar_02.glb"}
            speed={0.5}
            offset={200}
          />
          <GltfLoaderAni
            MeshPath={process.env.PUBLIC_URL + "/Geo/aniCar_03.glb"}
            speed={0.5}
          />

          <Lable position={[0, 30, -300]}>Oxford North</Lable>
          {/* ######### */}
        </Canvas>

        {!loaded && <LoadingScreen />}
      </div>
    );
  }
}
